import React from "react";
import "./../styles/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2024 Bonn'App - Tous droits réservés</p>
    </footer>
  );
}

export default Footer;
